var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartOutline = function SvgHeartOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.994 4.358C9.828 2.678 6.75 2.39 4.33 4.445c-2.702 2.293-3.1 6.168-.957 8.907.782 1 2.288 2.48 3.708 3.81a161 161 0 0 0 3.61 3.272c.064.057.16.141.254.212.117.087.3.208.551.282.324.096.67.096.994 0a1.7 1.7 0 0 0 .552-.282c.094-.07.19-.155.254-.212l.015-.013c.71-.625 2.15-1.904 3.595-3.258 1.42-1.332 2.925-2.81 3.708-3.811 2.13-2.725 1.8-6.63-.971-8.919-2.441-2.015-5.488-1.756-7.65-.075m-.991 2.628c-1.355-1.574-3.44-1.876-4.978-.571-1.654 1.404-1.87 3.713-.591 5.347.64.818 1.997 2.165 3.438 3.516a155 155 0 0 0 3.122 2.84c.767-.68 1.945-1.736 3.122-2.84 1.441-1.351 2.799-2.698 3.439-3.516 1.29-1.65 1.082-3.964-.578-5.336-1.589-1.31-3.647-1.002-4.992.56a1.308 1.308 0 0 1-1.982 0",
    clipRule: "evenodd"
  })));
};
export default SvgHeartOutline;